export * from './HeroImage'
export { default } from './HeroImage'
